import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { linearGradientDef } from "@nivo/core";
import Colors from "../../constants/Colors";

const dataTest = [
  {
    "Aisance à l'oral": 0.1,
    "Cohésion d'équipe": 0.3,
    Confiance: 0.65,
    Productivité: 0.1,
    Stress: 0.1,
    mois: "octobre",
    monthNumber: 9,
    users: 10
  }
];

const colorRange = [
  "rgba(252,87,122,0.8)",
  "#FFC233",
  "#FF9F40",
  "rgba(0,170,255,0.8)",
  "rgba(66,80,251,0.8)"
];

const EvolutionChart = ({ data, isSmall }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={["Stress", "Aisance à l'oral", "Confiance", "Cohésion d'équipe"]}
      indexBy="mois"
      margin={{
        top: 60,
        right: 0,
        bottom: 70,
        left: 25
      }}
      padding={isSmall ? 0.5 : 0.3}
      innerPadding={1}
      // minValue={-2}
      // maxValue={2}
      borderRadius={4}
      groupMode="grouped"
      colors={colorRange}
      colorBy={node => {
        if (node.id === "Stress") {
          return colorRange[0];
        }
        if (node.id === "Confiance") {
          return colorRange[1];
        }
        if (node.id === "Aisance à l'oral") {
          return colorRange[2];
        }
        if (node.id === "Cohésion d'équipe") {
          return colorRange[3];
        }
      }}
      borderColor="inherit:darker(1.6)"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 0,
        tickRotation: 0,
        // legend: "Mois",
        legendPosition: "middle",
        legendOffset: 32
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        // legend: "Évolution",
        legendPosition: "middle",
        legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor="inherit:darker(1.6)"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      enableLabel={false}
      enableGridY={false}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 60,
          itemsSpacing: 2,
          itemWidth: 120,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 15,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
    />
  );
};

export default EvolutionChart;
